import { post } from '@rails/request.js'

export default (klass) => class BloodPressureCheckMixin extends klass {

  static targets = [
    ...super.targets,
    'bloodPressureDiastolic',
    'bloodPressureSystolic',
    'repeatBloodPressure'
  ]

  static classes = [
    ...(super.classes ?? []),
    'hide'
  ]

  static values = {
    ...super.values,
    rangeCheckUrl: String
  }

  static outlets = [
    ...super.outlets,
    'consultation-note'
  ]

  // ==== Controllers

  // ==== Actions

  async checkBloodPressureRange(event) {
    this.consultationNoteOutlet.autoSave(event)

    const params = {
      blood_pressure: {
        blood_pressure_diastolic: this.bloodPressureDiastolicTarget.value,
        blood_pressure_systolic:  this.bloodPressureSystolicTarget.value
      }
    }

    const response = await post(this.rangeCheckUrlValue, { body: params })
    const body     = await response.json

    this.repeatBloodPressureTarget.classList.toggle(this.hideClass, !body.out_of_range)
  }

}
